import type { ReactElement, ReactNode } from 'react';
import { CustomizableErrorView } from './ErrorView';

/**
 * @deprecated Prefer using <ErrorFallback variant="inline" /> directly.
 * This component wraps ErrorFallback with default props for compact inline use.
 */
const ErrorMessage = ({
  children,
  title = 'Error',
}: {
  children?: ReactNode;
  title?: string;
}): ReactElement => {
  return <CustomizableErrorView title={title} content={children} variant="inline" />;
};

export default ErrorMessage;
